import { css } from '@emotion/react';
import { breakpoints } from '../../../styles';
import { SecondaryProps, p2r } from '../../../styles/fonts';

const styles = ({
  maxWidth,
  width,
  fontSize,
  lineHeight,
  fontWeight,
  letterSpacing = '-2.4px',
  mobileLetterSpacing = '-1.4px',
}) => css`
  width: ${width};
  max-width: ${maxWidth};
  margin: 0;
  font-size: ${p2r(fontSize)};
  font-weight: ${fontWeight};
  line-height: ${p2r(lineHeight)};
  letter-spacing: ${letterSpacing};

  @media (max-width: ${breakpoints.small}px) {
    font-size: ${p2r(56)};
    line-height: ${p2r(56)};
    letter-spacing: ${mobileLetterSpacing};
  }

  @media (max-width: ${breakpoints.netbook}px) {
    font-size: ${p2r(52)};
    line-height: ${p2r(52)};
  }

  @media (max-width: ${breakpoints.hugeMobile}px) {
    font-size: ${p2r(42)};
    line-height: ${p2r(42)};
  }

  ${SecondaryProps}
`;

export default styles;
